module.exports = __webpack_public_path__ + "static/blog-kubernetes-scheduler-ab0e5223030f27247dbec9d94aee48b5.jpeg";